export function ExitMieterhoehungModernisierung() {
  return (
    <>
      <h2>
        Leider können wir Mieterhöhungen aufgrund von Modernisierungen oder
        bauliche Maßnahmen noch nicht prüfen.
      </h2>
      <p>
        Vermieter dürfen generell die Miete aufgrund von Modernisierungen oder
        bauliche Maßnahmen erhöhen (§ 558 BGB). Es gibt hier jedoch viele
        Vorschriften und Aussnahmen, welche wir zur Zeit noch nicht durch diesen
        Fragebogen abdecken.
      </p>
      <h3>Was nun?</h3>
      <p>
        Es lohnt sich auf jeden Fall, die Mieterhöhung prüfen zu lassen. Bitte
        wenden dich hierfür eine Mietberatung.
      </p>
      <p>
        Deine Optionen hierfür erklären wir <a href="[TODO]">hier</a>.
      </p>
    </>
  );
}
